import 'react-rangeslider/lib/index.css';
import { FaUserCheck, FaUserTimes } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import { GoArrowDownRight, GoArrowUpRight } from 'react-icons/go';
import { LuActivity } from 'react-icons/lu';
import { RiTeamFill } from 'react-icons/ri';
import { useEffect, useState } from 'react';
import { getDashboardActivity } from '../../../redux/MainAction';
import { IoMdRefresh } from 'react-icons/io';

const MemberActivity = () => {
  const Act = useSelector((state) => state.Webtracker.dashboardActivity);

  const [defaultValue, setDefaultValue] = useState(0);
  const dispatch = useDispatch();
  const [firstRefresh, setFirstRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const formatPercentage = (percentValue) => {
    const roundedValue = Math.round(percentValue * 100) / 1000;
    return roundedValue ? `${roundedValue.toFixed(2)}%` : '0%';
  };

  useEffect(() => {
    if (Act) {
      setDefaultValue(formatPercentage(Act?.teamAverage) || 0);
    }
  }, [Act]);

  async function fetchDashboardData(isFirstRefresh) {
    setIsLoading(true);
    if (isFirstRefresh) setFirstRefresh(true);

    await dispatch(getDashboardActivity({ range: 'TODAY' }));

    setIsLoading(false);
  }

  return (
    <div className="col-6">
      <div className="card m-b-20 enhanced-card">
        <div className="border_class d-flex align-items-center justify-content-between">
          <h5 className="dash-card-title font-20 ml-3">
            <LuActivity className="font-20 mr-1 mb-1 dash-text-primary" />{' '}
            Members Activity
          </h5>

          {firstRefresh ? (
            <IoMdRefresh
              onClick={fetchDashboardData}
              title="Refresh Data"
              className="dashboard_reload_icon"
            />
          ) : null}
        </div>
        <div className="card-body dash_cards act_card2 p-0">
          {isLoading ? (
            <div className="d-flex align-items-center justify-content-center h-100">
              <div className="spinner-border text-primary " role="status"></div>
            </div>
          ) : firstRefresh ? (
            <>
              <div className="d-flex py-3 bg-white">
                <div
                  className="col-6 d-flex justify-content-start align-items-center "
                  style={{ color: '#23486A', fontSize: '17px' }}
                >
                  <RiTeamFill className="font-20 mr-1" /> Team Average
                </div>
                <div className="col-6 d-flex justify-content-center align-items-center">
                  <span id="right_badge">{defaultValue}</span>
                </div>
              </div>
              <hr className="mt-0" />
              <div className="row px-3 pb-3">
                <div className="col-6">
                  <h6
                    className="perform_head d-flex align-items-center"
                    style={{ color: '#23486A', fontSize: '17px' }}
                  >
                    <FaUserCheck className="font-20 mr-1" /> Best Performers{' '}
                    <span className="font-20 text-success">
                      {' '}
                      <GoArrowUpRight />
                    </span>
                  </h6>
                  <div className="performers_container">
                    {Act?.bestPerformers?.length > 0
                      ? Act?.bestPerformers?.map((perm, idx) => (
                          <div
                            key={idx}
                            className="d-flex justify-content-start align-items-center"
                            style={{ gap: '10px' }}
                          >
                            <span
                              className="border rounded text-white bg-indigo toad_icon d-flex justify-content-center align-items-center"
                              style={{
                                height: '40px',
                                width: '40px',
                                textTransform: 'uppercase',
                              }}
                            >
                              {perm?.userEmployeeRelation?.user?.firstName.charAt(
                                0
                              )}
                              {perm?.userEmployeeRelation?.user?.lastName.charAt(
                                0
                              )}
                            </span>
                            <div className="mt-2">
                              <span className="font-14">
                                {perm?.userEmployeeRelation?.user?.firstName}{' '}
                                {perm?.userEmployeeRelation?.user?.lastName}
                              </span>
                              <p className=" text-muted font-14">
                                {formatPercentage(perm?.completionPercent) ||
                                  0}{' '}
                              </p>
                            </div>
                          </div>
                        ))
                      : 'No Records Found'}
                  </div>
                </div>
                <div className="col-6">
                  <h6
                    className="perform_head"
                    style={{ color: '#23486A', fontSize: '17px' }}
                  >
                    <FaUserTimes className="font-20 mr-1" /> Worst Performers{' '}
                    <span className="font-18 text-danger">
                      {' '}
                      <GoArrowDownRight />
                    </span>
                  </h6>
                  <div className="performers_container">
                    {Act?.worstPerformers?.length > 0 ? (
                      Act?.worstPerformers?.map((perm, idx) => (
                        <div
                          key={idx}
                          className="d-flex justify-content-start align-items-center"
                          style={{ gap: '10px' }}
                        >
                          <span
                            className="border rounded text-white bg-info toad_icon d-flex justify-content-center align-items-center"
                            style={{ height: '40px', width: '40px' }}
                          >
                            {perm?.userEmployeeRelation?.user?.firstName.charAt(
                              0
                            )}
                            {perm?.userEmployeeRelation?.user?.lastName.charAt(
                              0
                            )}
                          </span>
                          <div className="mt-2">
                            <span className="font-14">
                              {perm?.userEmployeeRelation?.user?.firstName}{' '}
                              {perm?.userEmployeeRelation?.user?.lastName}
                            </span>
                            <p className=" text-muted font-14">
                              {formatPercentage(perm?.completionPercent) ||
                                0}{' '}
                            </p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="ml-3">No records Found</div>
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="d-flex align-items-center justify-content-center h-100">
              <button
                className="btn btn-primary font-14"
                onClick={() => fetchDashboardData(true)}
              >
                Load Data
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MemberActivity;
